// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","saveContactInfo__modal":"_1cjl4_mvQv9I","saveContactInfo__title":"_1NhpDX31h2nh","timelimit__wrp":"_2x2kad7AzHJX"};